import { render, staticRenderFns } from "./coord_file.vue?vue&type=template&id=52fc6f5d&scoped=true"
import script from "./coord_file.vue?vue&type=script&lang=js"
export * from "./coord_file.vue?vue&type=script&lang=js"
import style0 from "./coord_file.vue?vue&type=style&index=0&id=52fc6f5d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52fc6f5d",
  null
  
)

export default component.exports